window.Vue = require('vue');

Vue.component('header-top-bar', require('./HeaderTopBar.vue'));
Vue.component('section-title', require('./SectionTitle.vue'));
Vue.component('section-title-mobile-line', require('./SectionTitleMobileLine.vue'));
Vue.component('select-bike-dropdown', require('./SelectBikeDropdown.vue'));
Vue.component('footer-component', require('./Footer.vue'));
Vue.component('insert-plate', require('./InsertPlate.vue'));
Vue.component('license-plate-container', require('./LicensePlateContainer.vue'));
Vue.component('accordion-faq', require('./AccordionFaq.vue'));
Vue.component('section-title-after', require('./SectionTitleAfter.vue'));
Vue.component('bike-recap', require('./BikeRecap.vue'));
Vue.component('bike-notes', require('./BikeNotes.vue'));
Vue.component('loader', require('./Loader.vue'));
Vue.component('bike-equipment', require('./BikeEquipment.vue'));
Vue.component('inquiry', require('./Inquiry.vue'));
Vue.component('hero-box', require('./HeroBox.vue'));
Vue.component('hero-box-sponsor', require('./HeroBoxSponsor.vue'));
Vue.component('product-definition', require('./ProductDefinition.vue'));
Vue.component('stepper', require('./Stepper.vue'));
Vue.component('certificate-example', require('./CertificateExample.vue'));
Vue.component('product-explanation', require('./ProductExplanation.vue'));
Vue.component('buy-quotation-btn', require('./BuyQuotationBtn.vue'));
Vue.component('form-field-km', require('./FormFieldKm.vue'));
Vue.component('form-field-average', require('./FormFieldAverage.vue'));
Vue.component('form-field-date', require('./FormFieldDate.vue'));
Vue.component('form-field-add-info', require('./FormFieldAddInfo.vue'));
Vue.component('form-field-property', require('./FormFieldProperty.vue'));
Vue.component('form-fields', require('./FormFields.vue'));
Vue.component('date-filter', require('./DateFilter.vue'));
Vue.component('quotation-container', require('./QuotationContainer.vue'));
Vue.component('disclaimer-section', require('./DisclaimerSection.vue'));
Vue.component('vehicle-icon', require('./VehicleIcon.vue'));
Vue.component('bike-filter-container', require('./BikeFilterContainer.vue'));
Vue.component('find-equipment', require('./FindEquipment.vue'));
Vue.component('buy-quotation-form', require('./BuyQuotationForm.vue'));
Vue.component('buy-sponsored-form', require('./BuySponsoredForm.vue'));
Vue.component('classic-select-container', require('./ClassicSelectContainer.vue'));
Vue.component('select-classic-dropdown', require('./SelectClassicDropdown.vue'));
Vue.component('sw-alert', require('./SwAlert.vue'));
Vue.component('certificate-default', require('./CertificateDefault.vue'));
Vue.component('certificate-classic', require('./CertificateClassic.vue'));
Vue.component('classic-disclaimer', require('./ClassicDisclaimer.vue'));
Vue.component('tips-tricks', require('./TipsTricks.vue'));
Vue.component('classic-bike-data', require('./ClassicBikeData.vue'));
Vue.component('custom-select', require('./CustomSelect.vue'));
Vue.component('storic-select-container', require('./StoricSelectContainer.vue'));
Vue.component('select-storic-dropdown', require('./SelectStoricDropdown.vue'));
Vue.component('classic-bike-container', require('./ClassicBikeContainer.vue'));
Vue.component('card-product', require('./CardProduct.vue'));
Vue.component('livemarket-data-container', require('./LivemarketDataContainer.vue'));



// WEBPACK FOOTER //
// ./resources/js/app/components/vue-declarator.js